import Vue from 'vue'
import VueResource from 'vue-resource'
import VueRouter from 'vue-router'
import VuePaginate from 'vue-paginate'
import Buefy from 'buefy'
import VeeValidate from 'vee-validate'
import moment from 'moment'

import App from './app'

import router from './router'
import store from './store'
import {join} from './lib/url-join'

import './socket'
import './shotcodes'
import './filters'
import './directives'
import 'buefy/lib/buefy.css'

moment.locale('nl')

Vue.use(VueResource)
Vue.use(VueRouter)
Vue.use(VuePaginate)
Vue.use(VeeValidate)
Vue.use(Buefy, {
  defaultIconPack: 'fa',
  defaultDateFormatter: (date) => {
    return moment(date).format('DD/MM/YYYY')
  },
  defaultDateParser: (date) => {
    return moment(date, 'DD/MM/YYYY').toDate()
  }
})

Vue.http.interceptors.push((request, next) => {
  const hasNoHost = /^\//.test(request.url)
  const api = process.env.API

  if (hasNoHost) {
    request.url = join(api, request.url)
  }

  let { userID, accessToken } = store.getters

  if (userID) request.headers.set('user', userID)
  if (accessToken) request.headers.set('access', accessToken)

  next()
})

/* eslint-disable no-new */
new Vue({
  render: h => h(App),
  el: '#app',
  router,
  store
})



// WEBPACK FOOTER //
// ./src/main.js